import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Async Thunks for Blog Actions
export const createOutproperty = createAsyncThunk(
  "Outproperty/createOutproperty",
  async (formData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/create-outproperty", formData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOutpropertys = createAsyncThunk(
  "Outproperty/getOutpropertys",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api("/get-outpropertys");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// export const updateBlog = createAsyncThunk(
//   "blog/updateBlog",
//   async ({ id, formData }, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.put(`/update-blog/${id}`, formData, {
//         withCredentials: true,
//       });
//       return fulfillWithValue(data);
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// export const deleteBlog = createAsyncThunk(
//   "blog/deleteBlog",
//   async (id, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.delete(`/delete-blog/${id}`, {
//         withCredentials: true,
//       });
//       return fulfillWithValue(data);
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// Blog Reducer Slice
export const OutpropertyReducer = createSlice({
  name: "Outproperty",
  initialState: {
    Outpropertys: [],
    // Outproperty: {},
    totalOutpropertys: 0,
    successMessage: "",
    errorMessage: "",
    loader: false,
  },
  reducers: {
    messageClear: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
    clearOutProperty: (state) => {
      state.blog = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOutproperty.pending, (state) => {
        state.loader = true;
      })
      .addCase(createOutproperty.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(createOutproperty.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.totalOutpropertys = payload.totalOutpropertys;
        state.Outpropertys.push(payload.Outpropertys);
      })
      .addCase(getOutpropertys.pending, (state) => {
        state.loader = true;
      })
      .addCase(getOutpropertys.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.Outpropertys = payload.outpropertys;
      })
      .addCase(getOutpropertys.rejected, (state, { payload }) => {
        state.loader = false;
        state.error = payload.error;
      });
  },
});

export const { messageClear, clearOutProperty } = OutpropertyReducer.actions;

export default OutpropertyReducer.reducer;
